import React, { useState, useEffect } from 'react';
import { Box, Button, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, Typography, CircularProgress, Dialog } from '@mui/material';
import { FetchOrganizations } from '../../../../services/api';
import CreateOrganizationForm from './CreateOrganizationForm';

import usePermission from '../../../../hooks/usePermission';

const OrganizationsList = () => {
    const [orgs, setOrgs] = useState([]);
    const [loading, setLoading] = useState(true);
    const [openCreate, setOpenCreate] = useState(false);
    const token = localStorage.getItem('accessToken');
    const { can } = usePermission();

    useEffect(() => {
        loadOrgs();
    }, []);

    const loadOrgs = async () => {
        setLoading(true);
        const response = await FetchOrganizations(token);
        if (response?.data?.organizations) {
            setOrgs(response.data.organizations);
        } else if (response?.data?.data) { // Fallback for standard wrapper
            setOrgs(response.data.data);
        }
        setLoading(false);
    };

    if (loading) return <CircularProgress />;

    return (
        <Box>
             <Box display="flex" justifyContent="space-between" alignItems="center" mb={2}>
                <Typography variant="h5">Organizations</Typography>
                {can('settings.organizations.create') && (
                    <Button variant="contained" color="primary" onClick={() => setOpenCreate(true)}>Create Organization</Button>
                )}
            </Box>
             <TableContainer component={Paper}>
                <Table>
                    <TableHead>
                        <TableRow>
                            <TableCell>Name</TableCell>
                            <TableCell>Code</TableCell>
                            <TableCell>Type</TableCell>
                            <TableCell>Status</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {orgs.map((org) => (
                            <TableRow key={org.id}>
                                <TableCell>{org.organizationName}</TableCell>
                                <TableCell>{org.organizationCode}</TableCell>
                                <TableCell>{org.organizationType}</TableCell>
                                <TableCell>{org.isActive ? 'Active' : 'Inactive'}</TableCell>
                            </TableRow>
                        ))}
                    </TableBody>
                </Table>
            </TableContainer>

            <Dialog open={openCreate} onClose={() => setOpenCreate(false)} maxWidth="md" fullWidth>
                <CreateOrganizationForm onClose={() => setOpenCreate(false)} onSuccess={loadOrgs} />
            </Dialog>
        </Box>
    );
};

export default OrganizationsList;
